module.exports = __webpack_public_path__ + "static/media/patent.7282aba0.svg";